import React from "react";

export default ({className}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <polygon className="euiIcon__fillSecondary" points="7 9 7 11 0 11 0 0 23 0 23 7 21 7 21 2 2 2 2 9"/>
      <path d="M32,9 L32,21 L20,21 C13.9248678,21 9,16.0751322 9,10 L9,9 L32,9 Z M11.0549288,11 C11.5523731,15.4999505 15.3674463,19 20,19 L30,19 L30,11 L11.0549288,11 Z"/>
      <polygon className="euiIcon__fillSecondary" points="30 23 32 23 32 32 19 32 19 23 21 23 21 30 30 30"/>
    </g>
  </svg>
);
